import { useEffect } from 'react';
import { Amplitude, Tracking } from '@iwoca/frontend-tracking-library';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';

export const useTrackingIdentify = () => {
  const { introducerId, introducerType } = useIntroducerContext();

  useEffect(() => {
    if (introducerId) {
      Tracking.identifyUser(introducerId);
      Amplitude.identify(introducerId);
    }
  }, [introducerId]);

  useEffect(() => {
    if (introducerType) {
      Amplitude.setUserProperty('Introducer type', introducerType);
    }
  }, [introducerType]);

  useEffect(() => {
    Amplitude.setUserProperty('Browser width', window.innerWidth);
    Amplitude.setUserProperty('Browser height', window.innerHeight);
    Amplitude.setUserProperty(
      'Browser width maximum',
      window.screen.availWidth,
    );
    Amplitude.setUserProperty(
      'Browser height maximum',
      window.screen.availHeight,
    );
    Amplitude.setUserProperty('Device category', getDeviceCategory());
    Amplitude.setUserProperty('Browser zoom ratio', window.devicePixelRatio);
  }, []);
};

const getDeviceCategory = () => {
  const ua = navigator.userAgent;
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
    return 'Tablet';
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      ua,
    )
  ) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
};
